var requiredJSLoaded = false;

namespace Pages.Test._Camera.FrameRequestor {
    export async function __cdn_pages_test_framerequestor_onDocumentReadyAsync() {

        let defaultDate = Date.today();
        let showLight = true;
        let showDark = false;

        let login = new CDN.Controls.Login(document.querySelector('main'), {});

        let result = await login.successfulLoginAsync();

        if (result.UserToken == null) {
            toastr.showAlert("Error", result.Message ?? "Failed to log in", 'error');
            return;
        }

        login.hide();

        let controlDiv = $("<div>");

        $("main").append(controlDiv);

        let prodTxt = new CDN.Controls.UI.TextInput(controlDiv.get(0), {
            label: 'ProductID',
            placeholder: 'product',
            initialVal: '301',
        });
        prodTxt.container.style.width = '200px';

        let regTxt = new CDN.Controls.UI.TextInput<CDN.API.AutoComplete.v1.Vehicle>(controlDiv.get(0), {
            placeholder: 'registration',
            label: 'Registration',
            autocomplete: {
                searchAsync: async (term, cancellationToken) => {
                    let vehicles = await CDN.API.AutoComplete.v1.searchVehiclesAsync({
                        productId: prodTxt.value as CDN.Common.ProductId,
                        userToken: result.UserToken,
                    }, term, cancellationToken);

                    return vehicles.map(v => {
                        return {
                            label: v.Registration,
                            value: v.Registration,
                            data: v,
                        };
                    });
                },
                minLength: 3,
                onSelect: (value) => {

                    let createRequestor = (element: HTMLElement) => {
                        
                        let frameRequestor = new CDN.Camera.FrameRequestor(element, {
                            playerColumns: 4,
                            //requestManager: requestManager,
                            vehicle: {
                                vehicleId: value.VehicleId,
                                registration: value.Registration,
                                fleetNum: value.Fleetnum,
                            },
                            user: {
                                userToken: result.UserToken,
                                productId: prodTxt.value as CDN.Common.ProductId,
                            },
                            onLog: (lvl, msg, data) => {
                                switch (lvl) {
                                    case CDN.Common.LogLevel.SUCCESS:
                                    case CDN.Common.LogLevel.INFO:
                                        toastr.showAlert("Info", msg, 'info');
                                        console.log(msg);
                                        if (data) {
                                            console.log(data);
                                        }
                                        break;
                                    case CDN.Common.LogLevel.WARNING:
                                        toastr.showAlert('Warning', msg, 'warning');
                                        console.error(msg);
                                        if (data) {
                                            console.error(data);
                                        }
                                        break;
                                    case CDN.Common.LogLevel.ERROR:
                                    default:
                                        toastr.showAlert("Error", msg, 'error');
                                        console.error(msg);
                                        if (data) {
                                            console.error(data);
                                        }
                                        break;
                                }
                            },
                            onCamerasLoaded: (cameras: []) => {

                            },
                            onRequestStatusChange: (request) => {
                                switch (request.status) {
                                    case CDN.API.Camera.Player.v1.RequestStatus.Failed:
                                        toastr.showAlert(`Camera ${request.cameraName}`, `Footage {${request.dateTimeStart.format('yyyy/MM/dd HH:mm.ss')}} request failed.`, 'error');
                                        break;
                                    case CDN.API.Camera.Player.v1.RequestStatus.Cancelled:
                                        toastr.showAlert(`Camera ${request.cameraName}`, `Footage {${request.dateTimeStart.format('yyyy/MM/dd HH:mm.ss')}} request cancelled.`, 'warning');
                                        break;
                                    case CDN.API.Camera.Player.v1.RequestStatus.Complete:
                                        toastr.showAlert(`Camera ${request.cameraName}`, `Footage {${request.dateTimeStart.format('yyyy/MM/dd HH:mm.ss')}} request complete.`, 'success');
                                        break;
                                }
                            }
                        });

                        return frameRequestor;
                    }

                    if (lightFrameRequestor == null) {
                        lightFrameRequestor = createRequestor(rightBox.container);

                    } else {
                        lightFrameRequestor.user = {
                            userToken: result.UserToken,
                            productId: prodTxt.value as CDN.Common.ProductId,
                        };
                        lightFrameRequestor.setVehicle({
                            vehicleId: value.VehicleId,
                            registration: value.Registration,
                            fleetNum: "",
                        });
                    }
                },
            }
        });
        regTxt.container.style.width = '200px';
        regTxt.container.style.marginBottom = '10px';

        let layout = new CDN.Controls.Layout.FlexBox(document.querySelector('main'));
        layout.container.style.height = '800px';

        let leftBox = layout.add({
            
        });

        leftBox.container.style.marginRight = '10px';

        let rightBox = layout.add({
            grow: 1,
        });

        let lightFrameRequestor: CDN.Camera.FrameRequestor;

    }
}

var requiredJSLoaded = false;

CDN.requireOnce([
    { code: CDN.PackageCode.Component, },
    { code: CDN.PackageCode.JQuery, },
    { code: CDN.PackageCode.JQuery_UI, },
    { code: CDN.PackageCode.Common, },
    { code: CDN.PackageCode.Control_UI_Input, },
    { code: CDN.PackageCode.API_AutoComplete_v1, },
    { code: CDN.PackageCode.Control_Login, },
    { code: CDN.PackageCode.Camera_FrameRequestor, },
    { code: CDN.PackageCode.Toastr, },
    { code: CDN.PackageCode.Control_FlexBox, },
], () => {
    requiredJSLoaded = true;
    $(document).ready(Pages.Test._Camera.FrameRequestor.__cdn_pages_test_framerequestor_onDocumentReadyAsync);
});
